import { DirectionProvider } from '@radix-ui/react-direction';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { dirOf, isLocale } from './i18n';

/**
 * הכיוון של כל ה-primitives של Radix (Tabs, Select, Toast...) לפי השפה. Radix
 * מניח ltr כברירת מחדל, ובלי זה מסכים שלמים התהפכו. מתעדכן גם בהחלפת שפה בלי
 * טעינה מחדש (הרשמה, דפים ציבוריים).
 */
export function LocaleDirection({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();
  const lng = isLocale(i18n.language) ? i18n.language : 'he';
  return <DirectionProvider dir={dirOf(lng)}>{children}</DirectionProvider>;
}
